import {Component, Input, OnInit} from '@angular/core';
import {QuestionResult} from '../../../data/models/result/question-result';

@Component({
  selector: 'app-question-results',
  templateUrl: './question-results.component.html',
  styleUrls: ['./question-results.component.css']
})
export class QuestionResultsComponent implements OnInit {

  @Input() testId!: number;
  @Input() testResultId!: number;
  @Input() testType!: string;
  @Input() questionResults!: QuestionResult[];
  @Input() readonly = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
